import React from 'react';
import { BookmarkIcon as BookmarkOutline } from '@heroicons/react/24/solid';

interface ProfileEmptyStateProps {
  tab: number;         // 0 = created recipes, 1 = saved recipes
  isOwnProfile: boolean;
}

const ProfileEmptyState: React.FC<ProfileEmptyStateProps> = ({ tab, isOwnProfile }) => {
  // decide pronoun
  const pronoun = isOwnProfile ? 'You' : 'They';

  // decide main line
  const mainLine =
    tab === 0
      ? `${pronoun} haven't created any recipes yet`
      : `${pronoun} haven't saved any recipes yet`;

  return (
    <div className="w-full max-w-md text-center mx-auto">
      <p className="text-sm text-gray-500 mb-2">{mainLine}</p>

      {/* only show the “call to action” if it’s your own profile */}
      {isOwnProfile && (
        tab === 0 ? (
          <p className="text-lg text-gray-700 font-medium">
            Preserve a family favorite!
          </p>
        ) : (
          <p className="text-lg text-gray-700 font-medium">
            Tap on the{' '}
            <BookmarkOutline className="inline-block w-5 h-5 text-gray-400" /> on
            any recipe to see them here later on
          </p>
        )
      )}
    </div>
  );
};

export default ProfileEmptyState;
